import Drawer from "../../../drawer/Drawer";
import Button from "../../../form/Button";
import { motion } from "framer-motion";


const MediaDetails = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  const imageUrl =  data.url;
  const userLang = localStorage.getItem("lang");

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = data.name;
    link.click();
  };

  const copyLink = () => {
    navigator.clipboard.writeText(imageUrl);
  };

  return (
    <>
      <Drawer
        open={open}
        onClose={(val) => {
          close(val);
        }}
        actualSize={"xl"}
        size={"xl"}
        title={"File Details"}
        subtitle=""
        drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
      >
        <div className="h-full flex flex-col">
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            whileHover={{ scale: 1.02 }}
            className="h-1/2 bg-black"
          >
            <img
              src={imageUrl}
              alt={data?.captions?.[userLang]?.altText}
              className="w-full h-full object-contain bg-black transition-transform duration-500 ease-in-out"
            />
          </motion.div>
          <div className="h-1/2 overflow-y-auto bg-white px-6 py-6 shadow-inner rounded-t-3xl border-t border-gray-200">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
                {data?.captions?.[userLang]?.caption || "Media Information"}
              </h2>

              <div className="space-y-3 text-gray-700 text-sm text-center">
                <p>
                  <strong>File Name:</strong> {data.name}
                </p>
                <p>
                  <strong>Extension:</strong> {data.extension}
                </p>
                <p>
                  <strong>Size:</strong> {data.fileSizeReadable}
                </p>
                <p>
                  <strong>URL:</strong>{" "}
                  <a
                    href={imageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline break-all"
                  >
                    {imageUrl}
                  </a>
                </p>
              </div>

              {/* Actions */}
              <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
                <button
                  onClick={handleDownload}
                  className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-2 px-3 rounded-lg font-semibold transition"
                >
                  <i className="fa-solid fa-download"></i> Download
                </button>
                <button
                  onClick={copyLink}
                  className="flex items-center justify-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-3 rounded-lg transition"
                >
                  <i className="fa-solid fa-link"></i> Copy Link
                </button>
                <a
                  href={imageUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-3 rounded-lg transition"
                >
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>{" "}
                  Open
                </a>
                <button
                  onClick={() => window.open(imageUrl, "_blank")}
                  className="flex items-center justify-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-3 rounded-lg transition"
                >
                  <i className="fa-regular fa-photo-film-music"></i> Preview
                </button>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default MediaDetails;
